import React, {useState} from 'react';
import {ModalWrapper} from "../../components/ModalWrapper";
import {MDBBtn, MDBCol, MDBIcon, MDBRow} from "mdb-react-ui-kit";
import {disableUser, showErrorToast} from "../../helpers";

const DisableUserModal = ({username, isOpen, onClose}) => {
    const [isDisabling, setIsDisabling] = useState(false);

    const handleDisable = async () =>  {
        try {
            setIsDisabling(true);
            await disableUser(username);
            window.location.reload();
        } catch (error) {
            onClose();
            showErrorToast('Error while disabling user');
        } finally {
            setIsDisabling(false);
        }
    };

    return (
        <ModalWrapper
            title={'Disable user'}
            isOpen={isOpen}
            onClose={() => onClose()}
            modalClassSize={'modal-md'}
        >
            <MDBRow>
                <MDBCol>
                    <p>Do you really want to disable this user?</p>
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol>
                    <b>{username}</b>
                </MDBCol>
            </MDBRow>
            <div className="mt-5 d-flex justify-content-center">
                <MDBBtn
                    color={'danger'}
                    onClick={handleDisable}
                    disabled={isDisabling}
                >
                    {isDisabling &&
                        <MDBIcon icon='fas fa-solid fa-spinner fa-spin' className='me-3' size='xl'/>}
                    DISABLE
                </MDBBtn>
                <MDBBtn
                    color={'danger'}
                    outline={true}
                    className={'mx-3'}
                    onClick={onClose}
                    disabled={isDisabling}
                >
                    {isDisabling &&
                        <MDBIcon icon='fas fa-solid fa-spinner fa-spin' className='me-3' size='xl'/>}
                    CANCEL
                </MDBBtn>
            </div>
        </ModalWrapper>
    );
};

export default DisableUserModal;
